import { AxiosService } from './axios.service'

const baseURL = 'promocao-por-cupom'

export default class PromotionCouponService {
	/**
	 * Get the origins
	 * @return {Promise<any>} The list of origins
	 */
	static getUberPromotionCoupon() {
		return AxiosService.get(
			`${baseURL}/buscar-cupom-uber`
		).then(({ data }) => data)
	}

	/**
	 * Coupon information
	 * @param {string} orderNumber
	 */
	static getUberCouponByOrderNumber(orderNumber) {
		return AxiosService.get(
			`${baseURL}/buscar-cupom?orderNumber=${orderNumber}`
		)
			.then(({ data }) => data)
			.catch(() => [])
	}
}
